import { useQuery } from '@tanstack/react-query';
import { confidentialAPI } from '../services/api';
import { mapCountryOptions } from '../utils/countryOptionsUtils';

export const useCountryOptions = (options = {}) => {
  return useQuery({
    queryKey: ['hr-profile', 'country-options'],
    queryFn: async () => {
      const response = await confidentialAPI.getCountryOptions();
      return mapCountryOptions(response.data);
    },
    staleTime: 24 * 60 * 60 * 1000,
    ...options,
  });
};
